import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=2a668718&scoped=true&"
import script from "./BaseContainer.vue?vue&type=script&lang=js&"
export * from "./BaseContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a668718",
  null
  
)

export default component.exports